import React from 'react';

export default function Setting() {
  return <div className="fontPoppinsRegularLg">Settings</div>;
}
